import {
  testDetailConstants,
  downloadTestFileConstants,
} from "../_redux-constants";

export function testDetailReducer(
  state = {
    testDetailLoading: false,
    testDetailData: null,
    testDetailError: null,

    downloadTestFileLoading: false,
    downloadTestFileData: null,
    downloadTestFileError: null,
  },
  action
) {
  switch (action.type) {
    case testDetailConstants.TEST_DETAIL_LOADING:
      return Object.assign({}, state, {
        testDetailLoading: true,
        testDetailError: null,
      });
    case testDetailConstants.TEST_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        testDetailLoading: false,
        testDetailData: action.data,
      });
    case testDetailConstants.TEST_DETAIL_FAILURE:
      return Object.assign({}, state, {
        testDetailLoading: false,
        testDetailError: action.error,
      });

    case downloadTestFileConstants.DWNLD_TEST_FILE_LOADING:
      return Object.assign({}, state, {
        downloadTestFileLoading: true,
        downloadTestFileError: null,
      });
    case downloadTestFileConstants.DWNLD_TEST_FILE_SUCCESS:
      return Object.assign({}, state, {
        downloadTestFileLoading: false,
        downloadTestFileData: action.data,
      });
    case downloadTestFileConstants.DWNLD_TEST_FILE_FAILURE:
      return Object.assign({}, state, {
        downloadTestFileLoading: false,
        downloadTestFileError: action.error,
      });
    default:
      return state;
  }
}
